import { render, staticRenderFns } from "./roon-mining.vue?vue&type=template&id=7d18629f&scoped=true&"
import script from "./roon-mining.vue?vue&type=script&lang=js&"
export * from "./roon-mining.vue?vue&type=script&lang=js&"
import style0 from "./roon-mining.vue?vue&type=style&index=0&id=7d18629f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d18629f",
  null
  
)

export default component.exports